import { httpClient } from "@coworker/http-client";
import { useMutation } from "@tanstack/react-query";

async function uploadImageToStorage(file: File) {
  const formData = new FormData();
  formData.append("image", file);
  return await httpClient.tasks.upload<{ file_name: string }>(
    `/v1/storage/image-upload`,
    formData
  );
}

export function useUploadImageToStorage() {
  return useMutation({
    mutationFn: async (data: { file: File }) => {
      return await uploadImageToStorage(data.file);
    },
    onError: (error) => {
      console.log("Error while uploading image", error);
    },
  });
}
